// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_2mcxhIEQTbEXHzdsbP0j6y","Badge":"_20MYcuxmAI2BZF-fuLZU5L","ListWrapper":"_3ScWn0jl_Ck2IJVkR3JveL","List":"_3lE9aES3qRydIl5FB9ssJd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationBadge/styles.css
// module id = 742
// module chunks = 0